import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-editmapdata',
    templateUrl: './editmapdata.component.html',
    styleUrls: ['./editmapdata.component.scss'],
    standalone: false
})
export class EditmapdataComponent implements OnInit {

  selectedFile: File | undefined;
  editmapdata:FormGroup
  @Input() mapdatabyid:any; 
  submitted:boolean=false;
  isLoading: boolean = false;
  user_id:any;
  @Output() updateData: EventEmitter<any> = new EventEmitter();

  constructor(private formBuilder: FormBuilder,
    private dataserv: DataService,
    public activeModal: NgbActiveModal,
    private http: HttpClient,
    private toastService : ToastService,
    private currentUserService: CurrentUserService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = data.id;
        this.cdr.detectChanges();
      }
    })
    
    this.editmapdata = this.formBuilder.group({
      map_name: [this.mapdatabyid.map_name, [<any>Validators.required]],
      map_file: ['',[]],
      checkbox: [,[]],
      user_id: [this.user_id,[<any>Validators.required]],
    })
  }
  
 handleFileInput(event: any) {
  this.selectedFile = event.target.files[0];
 }

  onSubmit(){
    this.submitted=true;
    if (this.selectedFile) {
      this.isLoading = true;
      var formnewData: FormData = new FormData();
      formnewData.append('map_name',this.editmapdata.value.map_name);
      formnewData.append('map_file', this.selectedFile);
      formnewData.append('user_id', this.user_id);
      // Here you can perform further actions like sending the formData to the server
      
      this.dataserv.updatemap(formnewData).subscribe((res) => {
        if(res){
          this.toastService.showSuccess('Map updated.', 'success');
          this.isLoading = false;
          // Reload the list
          this.updateData.emit(this.editmapdata.value);
          this.closemodel();
        }
      
          this.cdr.detectChanges();},(error) => {
        this.isLoading = false;
        this.toastService.showSuccess(error.error.res, 'danger');
      
          this.cdr.detectChanges();})
      }
    }

  closemodel(){
    this.activeModal.close();
  }
}


